<!--
 * @Author: 仙道
 * @Date: 2022-06-22 20:33:36
 * @LastEditTime: 2022-06-25 14:02:42
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/workbench/components/menuModal.vue
-->
<template>
  <a-modal
    :confirmLoading="confirmLoading"
    :title="title"
    :visible="visible"
    :width="modalWidth"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <div class="bench-box">
        <div class="bench-box-list px-15px">
          <div :key="key" class="bench-box-list-item" v-for="([key,value]) in userRoutes">
            <div class="w-100px">
              <div class="icon-box">
                <a-icon :type="value.meta.icon" />
              </div>
            </div>
            <div class="flex-1 flex flex-col">
              <div class="bench-box-list-item-head flex justify-between">
                <span>{{value.meta.title}}</span>
                <a-button
                  :type="value.quickMenuId?'danger':''"
                  @click="addPanel(value)"
                  size="small"
                >{{value.quickMenuId?'删除':'添加'}}</a-button>
              </div>
              <!-- <div class="bench-box-list-item-desc mt-10px">{{value.desc}}</div> -->
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>

  import { deleteAction, httpAction } from '@/api/manage'
  import { mapActions, mapGetters } from 'vuex'
  export default {
    name: "QuickMenuModal",
    data () {
      return {
        title: "添加快捷菜单",
        modalWidth: 800,
        visible: false,
        confirmLoading: false,

        confirmDirty: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        form: this.$form.createForm(this),
        url: "sys/user/updatePassword",
        username: "",
      }
    },
    created () {
      // this.InitWorkbench()

    },
    // computed: {
    //   ...mapGetters['benchData']
    // },
    computed: {

      ...mapGetters(['benchData', 'layoutList', 'userRoutes', 'quickMenu']),
      menuRoutes () {
        return this.userRoutes
      }
    },
    methods: {
      ...mapActions(['InitWorkbench', 'refreshRoutes']),
      //添加组件
      async addPanel (menu) {

        const that = this
        if (menu.quickMenuId) {
          const result = await deleteAction('/custom/sysUserEntrance/delete', { id: menu.quickMenuId })
          if (result.success) {
            console.info('menulength===' + this.quickMenu.length)
            // this.$message.success('删除成功')
            await this.refreshRoutes({ menuId: menu.id, quickMenuId: menu.quickMenuId });
            // console.info('menulength===' + this.quickMenu.length)
            this.$forceUpdate()
          }

        } else {
          const result = await httpAction('/custom/sysUserEntrance/add', { permissionId: menu.id }, 'post')
          if (result.success) {
            console.info('menulength===' + this.quickMenu.length)
            this.$message.success('添加成功')
            await this.refreshRoutes({ menuId: menu.id })
            console.info('menulength===' + this.quickMenu.length)
            this.$forceUpdate()
          }
          //     .then(res => {
          //       this.$message.success('添加成功')
          //       console.info('menulength===' + this.quickMenu.length)
          //       await this.LoadUserQuickMenu()
          //       console.info('menulength===' + this.quickMenu.length)


          //       //this.refreshRoutes(menu.id) 
        }
        // }




      },
      show () {
        this.visible = true;
      },
      handleCancel () {
        this.close()
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
        this.selectedRole = [];
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        that.close();
      },
      validateToNextPassword (rule, value, callback) {
        const form = this.form;
        if (value && this.confirmDirty) {
          form.validateFields(['confirm'], { force: true })
        }
        callback();
      },
      compareToFirstPassword (rule, value, callback) {
        const form = this.form;
        if (value && value !== form.getFieldValue('password')) {
          callback('两次输入的密码不一样！');
        } else {
          callback()
        }
      },
      handleConfirmBlur (e) {
        const value = e.target.value
        this.confirmDirty = this.confirmDirty || !!value
      }

    }
  }
</script>

<style lang="less" scoped>
  .bench-box {
    height: 600px;
    overflow-y: scroll;
    &-list {
      display: grid;
      grid-template-columns: 49% 49%;
      grid-gap: 15px 15px;
      &-item {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        padding: 10px;
        border: 1px dashed #c2d6ff;
        border-radius: 8px;
        .icon-box {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: #f2f6fc;
          display: flex;
          justify-content: center;
          align-items: center;
          .anticon {
            border-radius: 20px;
            font-size: 20px;
            color: rgb(24, 144, 255);

            // color: #0000cc;
          }
        }
        &-head {
          span {
            color: #333;
            font-weight: 700;
            font-size: 17px;
          }
        }
      }
    }
  }
</style>

